/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import Icon1 from "../img/icon1.png";
import Icon2 from "../img/icon2.png";
import Icon3 from "../img/icon3.png";
import Icon4 from "../img/icon4.png";
import Icon5 from "../img/icon5.png";
import Icon6 from "../img/icon6.png";
import Icon7 from "../img/icon7.png";
import Icon8 from "../img/icon8.png";
import Icon9 from "../img/icon9.png";
import Icon10 from "../img/icon10.png";
import Icon11 from "../img/icon11.png";
import Icon12 from "../img/icon12.png";
import Icon13 from "../img/icon13.png";
import Icon14 from "../img/icon14.png";
import Icon15 from "../img/icon15.png";
import Icon16 from "../img/icon16.png";
import Icon17 from "../img/icon17.png";
import Icon18 from "../img/icon18.png";
import Icon19 from "../img/icon19.png";
import Icon20 from "../img/icon20.png";
import Icon21 from "../img/icon21.png";
import Icon22 from "../img/icon22.png";
import Icon23 from "../img/icon23.png";
import Icon24 from "../img/icon24.png";
import Icon25 from "../img/icon25.png";
import Icon26 from "../img/icon26.png";
import Icon27 from "../img/icon27.png";
import Icon28 from "../img/icon28.png";
import Icon29 from "../img/icon29.png";
import Icon30 from "../img/icon30.png";
import Icon31 from "../img/icon31.png";
import Icon32 from "../img/icon32.png";
import Icon33 from "../img/icon33.png";
import Icon34 from "../img/icon34.png";
import Icon35 from "../img/icon35.png";
import Icon36 from "../img/icon36.png";
import Icon37 from "../img/icon37.png";
import Icon38 from "../img/icon38.png";
import Icon39 from "../img/icon39.png";
import Icon40 from "../img/icon40.png";
import Icon41 from "../img/icon41.png";
import Icon42 from "../img/icon42.png";
import Icon43 from "../img/icon43.png";
import Icon44 from "../img/icon44.png";
import Icon45 from "../img/icon45.png";
import Icon46 from "../img/icon46.png";
import Icon47 from "../img/icon47.png";
import Icon48 from "../img/icon48.png";
import Icon49 from "../img/icon49.png";
import Icon50 from "../img/icon50.png";
import Icon51 from "../img/icon51.png";
import Icon52 from "../img/icon52.png";
import Icon53 from "../img/icon53.png";
import Icon54 from "../img/icon54.png";
import Icon55 from "../img/icon55.png";
import Icon56 from "../img/icon56.png";
import Icon57 from "../img/icon57.png";
import Icon58 from "../img/icon58.png";
import Icon59 from "../img/icon59.png";

const IconModal = () => {
  const {
    openIconPicker,
    setCanvasImg,
  } = useContext(PanelsContext);

  const images = [
    Icon1,
    Icon2,
    Icon3,
    Icon4,
    Icon5,
    Icon6,
    Icon7,
    Icon8,
    Icon9,
    Icon10,
    Icon11,
    Icon12,
    Icon13,
    Icon14,
    Icon15,
    Icon16,
    Icon17,
    Icon18,
    Icon19,
    Icon20,
    Icon21,
    Icon22,
    Icon23,
    Icon24,
    Icon25,
    Icon26,
    Icon27,
    Icon28,
    Icon29,
    Icon30,
    Icon31,
    Icon32,
    Icon33,
    Icon34,
    Icon35,
    Icon36,
    Icon37,
    Icon38,
    Icon39,
    Icon40,
    Icon41,
    Icon42,
    Icon43,
    Icon44,
    Icon45,
    Icon46,
    Icon47,
    Icon48,
    Icon49,
    Icon50,
    Icon51,
    Icon52,
    Icon53,
    Icon54,
    Icon55,
    Icon56,
    Icon57,
    Icon58,
    Icon59,
  ];

  return (
    <div
      css={styles}
      className={(openIconPicker ? "hidden" : "") + " iconModal"}
    >
      <div className="iconHeading">
        <h2>Select an Icon</h2>
      </div>
      <div className="iconContainer">
        {images.map((img, index) => (
          <img
            onClick={() => setCanvasImg(img)}
            key={index}
            src={img}
            alt="icon"
          />
        ))}
      </div>
    </div>
  );
};

const styles = css`
  width: 100%;
  max-width: 480px;
  min-width: 480px;
  background: #1e2431;
  position: absolute;
  top: -340px;
  left: 160px;
  padding: 20px;
  border-radius: 4px;
  &.hidden {
    display: none;
  }
  .iconHeading {
    padding: 0 0 18px 18px;
    h2 {
      color: #fff;
    }
  }
  .iconContainer {
    width: 100%;
    height: 310px;
    max-height: 310px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 50px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e6004e;
      border-radius: 50px;
    }
    img {
      width: 40px;
      height: 40px;
      display: block;
      margin: 14px;
      cursor: pointer;
    }
  }
`;

export default IconModal;
